<div class="pag-container">

  <app-kv-breadcrumb [arrayBreadcrumbs]="breadcrumbs"></app-kv-breadcrumb>

  <div class="ui-g-12 mt4">
    <div class="info-action">
      <span>{{ 'extlog.infoAction' | translate }}</span>
    </div>
  </div>

  <form [formGroup]="dateRangeForm">
    <div class="ui-g-12">

      <div class="ui-g-6" style="margin-top: 20px;">
        <div class="ui-g-8 d-flex align-items-center">
          <span class="title">{{ 'extlog.listTitle' | translate }}</span>
        </div>
        <div class="ui-g-4 d-flex align-items-center">
          <span class="title-span">{{ 'common.selectInterval' | translate }}</span>
        </div>
      </div>

      <div class="ui-g-3">
        <span class="date-range">{{ 'common.from' | translate }}</span>
        <br>
        <app-kv-calendar
          #dateStartField
          [inputName]="'startDate'"
          [formData]="dateRangeForm"
          [startDateSelector]="true"
        ></app-kv-calendar>
      </div>

      <div class="ui-g-3">
        <span class="date-range">{{ 'common.to' | translate }}</span>
        <br>
        <app-kv-calendar
          #dateEndField
          [inputName]="'endDate'"
          [formData]="dateRangeForm"
          [endDateSelector]="true"
        ></app-kv-calendar>
      </div>
    </div>
  </form>

  <div class="ui-g-12">
    <app-campaign-3-kontable
      #logListTable
      [columns]="[
        {field: 'id', title: 'ID'},
        {field: 'companyId', title: 'common.company', filterType: noFilter},
        {field: 'extetlCode', title: 'extlog.processing'},
        {field: 'tsStart', title: 'extlog.startTime', filterType: noFilter, bodyTemplate: startDateTemplate},
        {field: 'tsEnd', title: 'extlog.endTime', filterType: noFilter, bodyTemplate: endDateTemplate},
        {field: 'description', title: 'extlog.description', filterType: noFilter},
        {field: 'extlogStatusCode', title: 'extlog.status', filterType: selectFilter, filterOptions: {values: statusList}, bodyTemplate: statusTemplate}
      ]"
      [service]="extlogService"
      [paginationType]="paginationType"
      [showRecoverButton]="false"
      [showInfoButton]="false"
      [showAddButton]="false"
      [showDeleteButton]="false"
      [showDetailsButton]="false"
      [showEditButton]="false"
      [showGlobalFilter]="true"
      [filterStartDate]="dateRangeForm.get('startDate').value"
      [filterEndDate]="dateRangeForm.get('endDate').value"
      (onClearFilters)="clearDateFilters()"
      [filterBySingleColumn]="false"
      [expandTable]="true"
      [fetchNothing]="true"
      [customExpandedRowTemplate]="detailRowTemplate"
      [additionalRowCommands]="actions"
      (onRowExpanded)="getLogDetails($event)"
    >

      <ng-template #startDateTemplate data-testid="startDateTemplate" let-row>
        <span>{{ row.tsStart | date:'dd/MM/yyyy HH:mm:ss' }}</span>
      </ng-template>

      <ng-template #endDateTemplate data-testid="endDateTemplate" let-row>
        <span>{{ row.tsEnd | date:'dd/MM/yyyy HH:mm:ss' }}</span>
      </ng-template>

      <ng-template #statusTemplate data-testid="statusTemplate" let-row>
        <span class="status-dot" [ngClass]="getStatusDotClass(row)"></span>
        <span style="text-transform: uppercase;">{{ getStatusDescription(row) }}</span>
      </ng-template>

      <ng-template #detailRowTemplate data-testid="detailRowTemplate" let-row>
        <div>
          <app-extlog-table [extlogDetails]="logDetails"></app-extlog-table>
        </div>
      </ng-template>

      <ng-template #actions data-testid="actions" let-row>
        <div class="d-flex ">
          <button [hidden]="!row.isLogPresent" pTooltip="{{ 'extlog.downloadLogFile' | translate }}" class="roundedButton" (click)="downloadLogFile(row.id)">
            <i class="pi pi-file icon-size"></i>
          </button>
        </div>
      </ng-template>

    </app-campaign-3-kontable>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/extlog/extlog/extlog.component.html